<template>
    <div class="video-widget-component" style="display: none;" v-show="isShowVideoWidget">
        <div class="widget-container">
            <div class="button-container" v-show="!isShowRegForm">
                <a v-show="isUser" href="/declarations/" class="button button-filled" data-goal="video-widget-start">Начать бесплатно</a>
                <button v-show="!isUser" class="button button-filled" data-goal="video-widget-start" @click="toggleShowRegForm">Начать бесплатно</button>
            </div>

            <Registration v-show="!isUser && isShowRegForm" class="widget-rega" :is-mobile-view="true" :explanation-enabled="false" @callback="regCallback" registration-goal="reg_widget_video">
                <p class="reg-title">Представьтесь, чтобы получить бесплатную консультацию</p>
            </Registration>

            <button v-show="isShowRegForm" class="button close-reg" @click="toggleShowRegForm"></button>
            <button v-show="isShowVideoWidget && !isShowRegForm" class="button close-widget" @click="hideVideoWidget"></button>
        </div>
    </div>
</template>
<script>
import Registration from './registration.vue';

export default {
    name: 'VideoWidget',

    props: {
        isUser: {
            type: Boolean,
            default: false
        },
        links: {
            type: Object,
            default: {}
        },
    },

    components: {
        Registration
    },

    data () {
        return {
            isShowVideoWidget: false,
            isShowRegForm: false,
            stepLink: '/declarations/',
            isVideoStarted: false
        }
    },

    methods: {
        activateWidget() {
            this.toggleVideoSound();
            let videoFrame = document.querySelector('.video-widget-component');
            videoFrame.classList.toggle('active');
            document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'video_widget_toggle' }}));
        },

        toggleVideoSound() {
            let video = document.querySelector('.widget-video');
            video.muted = !video.muted;
            video.currentTime = 0;
        },

        showVideoWidget() {
            if (!this.isVideoStarted) {
                const container = document.querySelector('.widget-container');
                
                let videoHTML = this.createVideoHTML();
                container.insertBefore(videoHTML, container.firstChild);
                
                videoHTML.addEventListener('loadeddata', () => {
                    if (videoHTML.muted === false) {
                        videoHTML.muted = true;
                    }
                    videoHTML.play()
                    this.isShowVideoWidget = true;
                });

                this.isVideoStarted = true;
                window.removeEventListener('scroll', this.showVideoWidget);
            }
        },

        createVideoHTML() {
            let videoHTML = document.createElement("video");
            Object.assign(videoHTML, {
                className: 'widget-video',
                playsInline: true,
                muted: true,
                autoplay: true,
                loop: true,
                controlsList: 'nodownload',
                preload: 'auto',
                disablePictureInPicture: true,
                innerHTML: `
                <source src=${this.links.webm} type="video/webm">
                <source src=${this.links.mp4} type="video/mp4">`,
                onclick: this.activateWidget
            })
            return videoHTML;
        },

        hideVideoWidget() {
            this.isShowVideoWidget = false;
            let video = document.querySelector('.widget-video');
            video.pause();
            video.currentTime = 0;
        },

        toggleShowRegForm() {
            this.isShowRegForm = !this.isShowRegForm;
            this.toggleVideoSound();
        },

        regCallback() {
            location = this.stepsLink;
        }
    },

    mounted() {
        window.setTimeout(this.showVideoWidget, 5000);
        window.addEventListener('scroll', this.showVideoWidget);
    }
}
</script>